import { render, staticRenderFns } from "./Factorization.vue?vue&type=template&id=3ef868e0&lang=pug&"
import script from "./Factorization.vue?vue&type=script&lang=js&"
export * from "./Factorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports